// extracted by mini-css-extract-plugin
export default {"imageContainer":"m0-z","summaryPar":"n0-z","ratingCategories":"o0-z","reviewerInfo":"p0-z","reviewTypes":"q0-z","expanded":"r0-z"};